import { compose, curry, equals, prop } from 'ramda';

export const filterBy = curry((property, id) => compose(equals(id), prop(property)));
